// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-center-container {
  position: relative;
}

/* Bell Icon */
.notification-bell {
  position: relative;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-bell:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.bell-icon {
  font-size: 20px;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* Notification Panel */
.notification-panel {
  position: absolute;
  top: 50px;
  right: 0;
  width: 380px;
  max-height: 500px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.notification-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  flex-grow: 1;
}

.mark-all-read {
  background: none;
  border: none;
  color: #2196F3;
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}

.mark-all-read:hover {
  background-color: rgba(33, 150, 243, 0.1);
}

.mark-all-read:disabled {
  color: #ccc;
  cursor: default;
}

/* Filter Buttons */
.notification-filter {
  display: flex;
  border-bottom: 1px solid #eee;
}

.notification-filter button {
  flex: 1 1;
  padding: 12px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  position: relative;
}

.notification-filter button.active {
  color: #2196F3;
  font-weight: 500;
}

.notification-filter button.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #2196F3;
}

/* Notifications List */
.notifications-list {
  overflow-y: auto;
  flex: 1 1;
  padding: 0;
  max-height: 350px; /* Limit the height to ensure it fits nicely */
  scrollbar-width: thin;
}

.notifications-list::-webkit-scrollbar {
  width: 6px;
}

.notifications-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notifications-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.notifications-list::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.notification-item {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s ease;
  align-items: flex-start;
  position: relative;
  min-height: 60px; /* Ensure consistent height */
  max-height: 100px; /* Limit maximum height */
  overflow: hidden;
}

.notification-item:hover {
  background-color: #f5f9ff;
  transform: translateY(-1px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.notification-item:active {
  transform: translateY(0);
}

/* Add a subtle arrow indicator to show it's clickable */
.notification-item::after {
  content: '›';
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #ccc;
  opacity: 0;
  transition: opacity 0.2s ease, right 0.2s ease;
}

.notification-item:hover::after {
  opacity: 1;
  right: 12px;
}

/* Adjust the action button position to not overlap with the arrow */
.notification-item .notification-action {
  position: relative;
  z-index: 2;
}

.notification-item.unread {
  background-color: rgba(33, 150, 243, 0.05);
}

.notification-item.unread:hover {
  background-color: rgba(33, 150, 243, 0.1);
}

.notification-icon {
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0;
  padding-top: 2px;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.notification-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
  line-height: 1.4;
  white-space: normal;
  overflow: visible;
  display: block;
}

.notification-time {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}

/* Notification Action Button */
.notification-action {
  margin-left: 8px;
  background-color: #3498db;
  color: white;
  border: none;
  font-size: 0.75rem;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  align-self: flex-start;
  height: fit-content;
  transition: background-color 0.2s;
}

.notification-action:hover {
  background-color: #2980b9;
}

/* Priority Styles */
.priority-high {
  border-left: 3px solid #f44336;
}

.priority-medium {
  border-left: 3px solid #ff9800;
}

.priority-low {
  border-left: 3px solid #4caf50;
}

/* Status and Points Styles */
.status, .points {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status.valid {
  background-color: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status.expired, .status.suspended, .status.revoked, .status.disqualified {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.points {
  background-color: rgba(0, 0, 0, 0.1);
}

.points-low {
  background-color: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.points-medium {
  background-color: rgba(255, 152, 0, 0.1);
  color: #ff9800;
}

.points-high {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

/* Loading, Error, and Empty States */
.notification-loading,
.notification-error,
.no-notifications {
  padding: 24px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.notification-error {
  color: #f44336;
}

/* Footer */
.notification-footer {
  padding: 12px;
  text-align: center;
  border-top: 1px solid #eee;
  background-color: #f9f9f9;
}

.notification-footer a {
  color: #2196F3;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: block;
  padding: 4px;
}

.notification-footer a:hover {
  text-decoration: underline;
}

/* Notification Text Styling */
.notification-text {
  word-break: break-word;
  overflow-wrap: break-word;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines by default */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  line-height: 1.4;
}

/* Status and Points Styling - Make them more compact in notifications */
.notification-text .status,
.notification-text .points {
  display: inline-block;
  font-weight: 500;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 0.8rem;
  white-space: nowrap;
}

/* Add these styles for the refresh button */
.refresh-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-right: 8px;
}

.refresh-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #2196F3;
  transform: scale(1.1);
}

.refresh-btn:active {
  transform: scale(0.95);
}

.refresh-icon {
  transition: transform 0.5s ease;
}

.refresh-btn:hover .refresh-icon {
  transform: rotate(180deg);
}

/* When hovering, show the full message */
.notification-item:hover .notification-text {
  -webkit-line-clamp: unset;
  max-height: none;
  overflow: visible;
  z-index: 10;
  position: relative;
}

/* Load More Button */
.load-more-container {
  padding: 10px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
}

.load-more-btn {
  background-color: #f5f5f5;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.load-more-btn:hover {
  background-color: #e0e0e0;
  color: #333;
}

.load-more-btn:active {
  transform: scale(0.98);
}

/* Notification Count Summary */
.notification-count-summary {
  padding: 8px 16px;
  text-align: center;
  font-size: 12px;
  color: #888;
  background-color: #f9f9f9;
  border-top: 1px solid #eee;
}

/* Responsive Adjustments */
@media (max-width: 480px) {
  .notification-panel {
    width: 300px;
    right: -70px; /* Adjust position for smaller screens */
    max-height: 450px;
  }
  
  .notifications-list {
    max-height: 300px;
  }
  
  .notification-item {
    padding: 10px 12px;
    min-height: 50px;
  }
  
  .notification-message {
    font-size: 0.8rem;
  }
  
  .notification-action {
    padding: 2px 5px;
    font-size: 0.7rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/NotificationCenter.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAO;EACP,UAAU;EACV,iBAAiB,EAAE,8CAA8C;EACjE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,EAAE,6BAA6B;EAC/C,iBAAiB,EAAE,yBAAyB;EAC5C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;;EAGE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,qBAAqB,EAAE,gCAAgC;EACvD,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,YAAY,EAAE,wCAAwC;IACtD,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".notification-center-container {\n  position: relative;\n}\n\n/* Bell Icon */\n.notification-bell {\n  position: relative;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.1);\n  transition: background-color 0.2s;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-bell:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.bell-icon {\n  font-size: 20px;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #f44336;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n/* Notification Panel */\n.notification-panel {\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: 380px;\n  max-height: 500px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n  flex-grow: 1;\n}\n\n.mark-all-read {\n  background: none;\n  border: none;\n  color: #2196F3;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.mark-all-read:hover {\n  background-color: rgba(33, 150, 243, 0.1);\n}\n\n.mark-all-read:disabled {\n  color: #ccc;\n  cursor: default;\n}\n\n/* Filter Buttons */\n.notification-filter {\n  display: flex;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-filter button {\n  flex: 1;\n  padding: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  position: relative;\n}\n\n.notification-filter button.active {\n  color: #2196F3;\n  font-weight: 500;\n}\n\n.notification-filter button.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #2196F3;\n}\n\n/* Notifications List */\n.notifications-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 0;\n  max-height: 350px; /* Limit the height to ensure it fits nicely */\n  scrollbar-width: thin;\n}\n\n.notifications-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notifications-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.notifications-list::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 3px;\n}\n\n.notifications-list::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n\n.notification-item {\n  display: flex;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  align-items: flex-start;\n  position: relative;\n  min-height: 60px; /* Ensure consistent height */\n  max-height: 100px; /* Limit maximum height */\n  overflow: hidden;\n}\n\n.notification-item:hover {\n  background-color: #f5f9ff;\n  transform: translateY(-1px);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.notification-item:active {\n  transform: translateY(0);\n}\n\n/* Add a subtle arrow indicator to show it's clickable */\n.notification-item::after {\n  content: '›';\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 20px;\n  color: #ccc;\n  opacity: 0;\n  transition: opacity 0.2s ease, right 0.2s ease;\n}\n\n.notification-item:hover::after {\n  opacity: 1;\n  right: 12px;\n}\n\n/* Adjust the action button position to not overlap with the arrow */\n.notification-item .notification-action {\n  position: relative;\n  z-index: 2;\n}\n\n.notification-item.unread {\n  background-color: rgba(33, 150, 243, 0.05);\n}\n\n.notification-item.unread:hover {\n  background-color: rgba(33, 150, 243, 0.1);\n}\n\n.notification-icon {\n  margin-right: 12px;\n  font-size: 20px;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.notification-message {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 4px;\n  line-height: 1.4;\n  white-space: normal;\n  overflow: visible;\n  display: block;\n}\n\n.notification-time {\n  font-size: 11px;\n  color: #999;\n  margin-top: 4px;\n}\n\n/* Notification Action Button */\n.notification-action {\n  margin-left: 8px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  font-size: 0.75rem;\n  padding: 3px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  align-self: flex-start;\n  height: fit-content;\n  transition: background-color 0.2s;\n}\n\n.notification-action:hover {\n  background-color: #2980b9;\n}\n\n/* Priority Styles */\n.priority-high {\n  border-left: 3px solid #f44336;\n}\n\n.priority-medium {\n  border-left: 3px solid #ff9800;\n}\n\n.priority-low {\n  border-left: 3px solid #4caf50;\n}\n\n/* Status and Points Styles */\n.status, .points {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status.valid {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #4caf50;\n}\n\n.status.expired, .status.suspended, .status.revoked, .status.disqualified {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n.points {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.points-low {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #4caf50;\n}\n\n.points-medium {\n  background-color: rgba(255, 152, 0, 0.1);\n  color: #ff9800;\n}\n\n.points-high {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n}\n\n/* Loading, Error, and Empty States */\n.notification-loading,\n.notification-error,\n.no-notifications {\n  padding: 24px;\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.notification-error {\n  color: #f44336;\n}\n\n/* Footer */\n.notification-footer {\n  padding: 12px;\n  text-align: center;\n  border-top: 1px solid #eee;\n  background-color: #f9f9f9;\n}\n\n.notification-footer a {\n  color: #2196F3;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  display: block;\n  padding: 4px;\n}\n\n.notification-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Notification Text Styling */\n.notification-text {\n  word-break: break-word;\n  overflow-wrap: break-word;\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Limit to 2 lines by default */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* Status and Points Styling - Make them more compact in notifications */\n.notification-text .status,\n.notification-text .points {\n  display: inline-block;\n  font-weight: 500;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n/* Add these styles for the refresh button */\n.refresh-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 6px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  margin-right: 8px;\n}\n\n.refresh-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #2196F3;\n  transform: scale(1.1);\n}\n\n.refresh-btn:active {\n  transform: scale(0.95);\n}\n\n.refresh-icon {\n  transition: transform 0.5s ease;\n}\n\n.refresh-btn:hover .refresh-icon {\n  transform: rotate(180deg);\n}\n\n/* When hovering, show the full message */\n.notification-item:hover .notification-text {\n  -webkit-line-clamp: unset;\n  max-height: none;\n  overflow: visible;\n  z-index: 10;\n  position: relative;\n}\n\n/* Load More Button */\n.load-more-container {\n  padding: 10px;\n  text-align: center;\n  border-top: 1px solid #f0f0f0;\n}\n\n.load-more-btn {\n  background-color: #f5f5f5;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 13px;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.load-more-btn:hover {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.load-more-btn:active {\n  transform: scale(0.98);\n}\n\n/* Notification Count Summary */\n.notification-count-summary {\n  padding: 8px 16px;\n  text-align: center;\n  font-size: 12px;\n  color: #888;\n  background-color: #f9f9f9;\n  border-top: 1px solid #eee;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 480px) {\n  .notification-panel {\n    width: 300px;\n    right: -70px; /* Adjust position for smaller screens */\n    max-height: 450px;\n  }\n  \n  .notifications-list {\n    max-height: 300px;\n  }\n  \n  .notification-item {\n    padding: 10px 12px;\n    min-height: 50px;\n  }\n  \n  .notification-message {\n    font-size: 0.8rem;\n  }\n  \n  .notification-action {\n    padding: 2px 5px;\n    font-size: 0.7rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
